import Collection from './collection.js';
import Payslip from 'newModels/payslip.js';
import Decimal from 'decimal.js';

export default class PayrollSummary extends Collection {
    url() {
        if (this.payroll) {
            return `${this.payroll.url()}/slips`;
        }

        return `/Payslips`;
    }

    initialize(models, {payroll = null}) {
        this.model = Payslip;
        this.payroll = payroll;
        if (models && models.length > 0) {
            throw new Error(`Can't initialize model for this report`);
        }
        super.initialize(...arguments);
        if (!this.options.sortKey) {
            this.options.sortKey = 'employeeName';
        }
        this.totals = null;
        this.pageTotals = [];
        return this;
    }

    /**
     * Get the summary totals of all the models currently present in the
     * collection
     *
     * @instance
     * @returns {Object} totals
     * @todo define type for totals
     */
    getTotals() {
        const result = {};

        [
            'base',
            'netPay',
            'grossPay',
            'mtd',
            'employeeEpf',
            'employerEpf',
            'employeeSocso',
            'employerSocso',
            'employeeEis',
            'employerEis',
            'additions',
            'deductions',
            'zakat',
            'cp38'
        ].forEach(key => {
            result[key] = this.reduce(
                (m, obj) => m.plus((obj.get(key) || 0)),
                new Decimal(0)
            ).toDP(2, Decimal.ROUND_HALF_UP).toNumber();
        });

        result.hrdf = this.models.reduce(
            (a, m) => a.plus(m.getHrdf()),
            new Decimal(0)
        ).toDP(2, Decimal.ROUND_HALF_UP).toNumber();

        return result;
    }

    /**
     * Override save because this is a readonly collection
     *
     * @instance
     */
    save() {
        throw new Error(`Can't save a report`);
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payroll-summary.js